<template>
    <div class="modal-card pop_min" id="draggable" style="overflow-y:hidden">
        <header class="modal-card-head pop-header">
            <button class="icon is-right" @click="move" style="position:absolute;top:18px;right:70px;z-index:30;"><i class="fas fa-window-maximize" style="color:#fff;font-size:22px;padding-top:1px"></i></button>
            <p class="modal-card-title tit">
                {{ title }}
                <button class="btn-pop-close delete" aria-label="close" @click="$parent.close()"></button>
            </p>
        </header>
        <section class="modal-card-body pop-content">
        <div class="inner-box">
            <div class="table-b" style="margin-bottom: 10px">
                <div class="table-header">
                    <div class="table-name">
                        <h3 class="ico_table_name">SMS 작성</h3>
                    </div>
                    <div class="btn-wrap btn-type1 clearfix fl_right">
                        <div class="dp-ib fl_left">
                            <button class="btn-size btn-blue" @click="sendSms()">
                                <span class="btn-icon"><i class="fas fa-comment"></i></span> 발신
                            </button>
                        </div>
                    </div>
                </div>
                <div class="grid-wrap">
                    <table class="visit-info-table">
                        <colgroup>
                            <col width="35%">
                            <col width="*">
                        </colgroup>
                        <tr>
                            <td class="tit">수신자 연락처</td>
                            <td>
                                <div class="write">
                                    <select style="padding:10px 25px 10px 10px" v-model="form.receiveMobile1">
                                        <option
                                                v-for="item in mobiles"
                                                :key="item"
                                                :value="item"
                                                v-text="item"/>
                                    </select>&nbsp;
                                    <input class="input" type="text" maxlength="4" style="width:60px;" ref="form.receiveMobile2" v-model="form.receiveMobile2">&nbsp;
                                    <input class="input" type="text" maxlength="4" style="width:60px;" ref="form.receiveMobile3" v-model="form.receiveMobile3">
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td class="tit">내용[{{smsLength}}/66]</td>
                            <td>
                                <p v-if="this.$store.state.loginInfo.compCd === 'E0000001'">방문신청 링크 : [vms.lottechem.com{{this.compLink}}]</p>
                                <p v-else>LEM 방문신청 링크 : [vms.lottechem.com{{this.compLink}}]</p>
                                <textarea class="textarea" placeholder="상세 내용을 작성해주세요." v-model="form.content" style="resize:none" maxlength="22"></textarea>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>

        </div>
    </section>
    </div>
</template>

<script>
    import _ from "lodash";

    export default {
        props: {
            loginId: {
                type: String,
                required: false
            },
            loginNm: {
                type: String,
                required: false
            },
        },
        data() {
            return {
                title: '방문신청 안내 문자 발송',
                mobiles:['010','011','016','017','018','019'],
                form: {
                    receiveMobile: '',
                    receiveMobile1: '010',
                    receiveMobile2: '',
                    receiveMobile3: '',
                    content: '',
                    sendContent: '',
                },
                compLink:'',
                smsLength: '',
                loaded: false,
                isNew: false,
                isMxMn: true
            }
        },
        methods: {
            move() {
                if(this.isMxMn) {
                    $(".modal-card").removeClass('pop_min')
                    $(".modal-card").addClass('pop_max');

                    $(".animation-content").removeClass('pop_min')
                    $(".animation-content").addClass('pop_max');
                    this.isMxMn = false
                } else {
                    $(".modal-card").removeClass('pop_max')
                    $(".modal-card").addClass('pop_min');

                    $(".animation-content").removeClass('pop_max')
                    $(".animation-content").addClass('pop_min');
                    this.isMxMn = true
                }
            },
            sendSms() {

                this.$swal({
                    type: 'info',
                    text: `문자메세지를 발송합니다. 계속 하시겠습니까?`,
                    showCancelButton: true,
                    confirmButtonText: '예',
                    cancelButtonText: '아니오',
                }).then((result) => {
                    if (result.value) {
                        this.$store.commit('loading')

                        if(this.$store.state.loginInfo.compCd === 'E0000001') {
                            this.form.sendContent = '방문신청 링크 : [vms.lottechem.com'+ this.compLink +'] ' + this.form.content
                        } else {
                            this.form.sendContent = 'LEM 방문신청 링크 : [vms.lottechem.com'+ this.compLink +'] ' + this.form.content
                        }
                        
                        const param = JSON.parse(JSON.stringify(this.form))
                        this.$http.post(`/api/v1/sendGuideSms`, param
                        ).then((response) => {
                            this.$parent.close()
                            this.$swal({type: 'info', text: '완료되었습니다.'})
                        }).catch((e) => {
                            console.error(e);
                        });
                    }
                }).finally(()=>{
                    this.$store.commit('finish')
                })
            },
        },
        watch: {
            'form.receiveMobile1' : {
                immediate: true,
                deep: true,
                handler() {
                    this.form.receiveMobile = this.form.receiveMobile1 + this.form.receiveMobile2 + this.form.receiveMobile3;
                },
            },

            'form.receiveMobile2' : {
                immediate: true,
                deep: true,
                handler() {
                    this.form.receiveMobile = this.form.receiveMobile1 + this.form.receiveMobile2 + this.form.receiveMobile3;
                    this.form.receiveMobile2 = this.form.receiveMobile2.replace(/-/g, '').replace(/[^0-9]/g,'');
                },
            },
            'form.receiveMobile3' : {
                immediate: true,
                deep: true,
                handler() {
                    this.form.receiveMobile = this.form.receiveMobile1 + this.form.receiveMobile2 + this.form.receiveMobile3;
                    this.form.receiveMobile3 = this.form.receiveMobile3.replace(/-/g, '').replace(/[^0-9]/g,'');
                },
            },
            'form.content' : {
                immediate: true,
                deep: true,
                handler(value) {
                    this.smsLength = (function (s, b, i, c) {
                        for (b = i = 0; c = s.charCodeAt(i++); b += c >> 11 ? 3 : c >> 7 ? 3 : 1) ;
                        return b
                    })(value);
                }
            },

        },
        created() {
            if(this.$store.state.loginInfo.compCd === 'E0000001') {
                this.compLink = '/ijmt'
            } else if(this.$store.state.loginInfo.compCd === '222222') {
                this.compLink = '/ijbh'
            } else if(this.$store.state.loginInfo.compCd === '100010') {
                this.compLink = '/ijel'
            } else if(this.$store.state.loginInfo.compCd === '101600') {
                this.compLink = '/ijcs'
            } else if(this.$store.state.loginInfo.compCd === '101301') {
                this.compLink = '/ijdm'
            } else if(this.$store.state.loginInfo.compCd === '100015') {
                this.compLink = '/ijst'
            } else if(this.$store.state.loginInfo.compCd === '100002') {
                this.compLink = '/ijhd'
            } else if(this.$store.state.loginInfo.compCd === '222300') {
                this.compLink = '/ijap'
            }
        },
        mounted() {
            //pop slots modal move
            $(".animation-content").addClass('pop_min');
            $(".animation-content").draggable();
            //ModalSlot open z-index change
            $('.lnb').css('z-index', '4');
        },
        destroyed() {
            //ModalSlot open z-index change
            $('.lnb').css('z-index', '7');
        },
    }
</script>

<style scoped>
    .modal-card {
        width: auto;
    }

    .modal table {
        border-right: #adadad solid 0px;
    }

    .visit-info-table{
        border-top: 1px solid #aaaaaa;
        width: 100%;
    }

    .visit-info-table td {
        border-bottom: 1px solid #ddd;
        border-left:0px;
        color: #999;
        padding: 10px 0 10px 10px;
        font-size: 14px;
        vertical-align: middle;
    }

    .visit-info-table td input{
        width: 35%;
        height: 40px;
    }

    .visit-info-table td p input{
        width: 100%;
    }

    .visit-info-table td select{
        padding:10px 40px 10px 15px;
    }

    .visit-info-table td.tit{
        background: #f9f9f9;
        padding-left: 30px;
        color: #666;
        line-height: normal;
    }

    .visit-info-table td button{
        margin-left:10px;
    }

    .visit-info-list ul li .write {
        text-align: left;
        padding: 10px 0 10px 10px;
        vertical-align: middle;
    }

    .visit-info-list ul li .write {
        padding: 10px 0 10px 5px;
        width: 100%;
        text-align: center;
    }

</style>
